<i18n>
{
	"en": {
		"title": "Deviation Type"
	},
	"no": {
		"title": "Avvikstype"
	}
}
</i18n>

<template>
	<t-combobox
		:title="$t('title')"
		:showCount="false"
		showPopoverOnFocus

		:searchValue="searchValue"
		:items="deviationTypes"
		:selected="value"

		:disabled="disabled || hasNoDeviationTypes"

		:filterFunction="filterFunction"
		:sortFunction="sortFunction"

		@input="onInput"
		@change="onChange"
		@blur="onBlur"
	>
		<template #optionItemContent="slotProps">
			<div class="item">
				<div class="item-main-text">{{ `${slotProps.item.code} - ${slotProps.item.description}` }}</div>
			</div>
		</template>
	</t-combobox>
</template>

<script>
import { mapState, mapActions } from './store/deviations.store';

export default {
	name: 'DeviationTypeInput',
	props: {
		value: Object,
		disabled: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			searchValue: '',
		};
	},
	computed: {
		...mapState(['deviationTypes']),
		hasNoDeviationTypes() {
			return !this.deviationTypes || this.deviationTypes.length === 0;
		},
	},
	watch: {
		value: {
			immediate: true,

			handler(deviationType) {
				if (!deviationType || Object.keys(deviationType).length === 0) {
					this.searchValue = '';
				} else if (deviationType.code) {
					this.searchValue = deviationType.code;
				}
			}
		}
	},
	async created() {
		await this.getDeviationTypes();
	},
	methods: {
		...mapActions(['getDeviationTypes']),

		onInput(searchValue) {
			this.searchValue = searchValue.toUpperCase();
		},

		onChange(event) {
			if (event && event.code) {
				this.searchValue = event.code;
				this.$emit('change', event);
			} else
				this.$emit('change', undefined);
		},

		onBlur() {
			if (this.searchValue === '') {

				this.$emit('change', undefined);
				return;
			}

			let deviationType = this.deviationTypes.find(
				deviationType => this.searchValue.toLowerCase() === deviationType.code.toLowerCase()
			);

			if (deviationType && deviationType !== this.value) {
				this.$emit('change', deviationType);

			} else
				this.searchValue = this.getSearchValueFromValue(this.value);
		},
		getSearchValueFromValue(value) {
			if (value && value.code && value.code.length)
				return value.code;
			else
				return '';
		},

		filterFunction(deviationType) {
			return deviationType.code.toLowerCase().includes(this.searchValue.toLowerCase());
		},
		sortFunction: (a, b) => {
			if (a.code < b.code) return -1;
			if (a.code > b.code) return 1;
			return 0;
		},
	}
};
</script>
